import { render, staticRenderFns } from "./MedicationInstructionTab.vue?vue&type=template&id=33c2e615&scoped=true&"
import script from "./MedicationInstructionTab.vue?vue&type=script&lang=ts&"
export * from "./MedicationInstructionTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c2e615",
  null
  
)

export default component.exports